module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.signinForm.createdAt) ? _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-12",
    attrs: {
      "color": "secondary",
      "elevate-on-scroll": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Creator Signin Form")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "view-signinform-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "signInForm",
    staticClass: "sign-in-form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-center": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "default-title font-weight-bold mb-2"
  }, [_vm._v("Date: " + _vm._s(_vm.utils.formatCustomDate(_vm.signinForm.createdAt, 'DD/MM/YYYY')))])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "address-title"
  }, [_vm._v("\n                    Kobe Global Technologies Pte Ltd."), _c('br'), _vm._v("\n                    GST Registration no. 201608755R"), _c('br'), _vm._v("\n                    51 Goldhill Plaza"), _c('br'), _vm._v("\n                    #14-01"), _c('br'), _vm._v("\n                    Singapore 308900"), _c('br'), _vm._v("\n                    finance@getkobe.com\n                  ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "default-title mb-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Client:")]), _vm._v(" " + _vm._s(_vm.displayData.clientName))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mb-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "default-title mb-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Campaign Name:")]), _vm._v(" " + _vm._s(_vm.displayData.campaignName))]), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Creator:")]), _vm._v(" @" + _vm._s(_vm.displayData.handle) + " on " + _vm._s(_vm.displayData.platform))]), _vm._v("\n                  (\n                    "), (_vm.platform === 'youtube') ? _c('a', {
    attrs: {
      "href": ("https://www.youtube.com/@" + (_vm.displayData.handle)),
      "target": "_blank"
    }
  }, [_vm._v("https://www.youtube.com/" + _vm._s(_vm.displayData.handle))]) : (_vm.platform === 'tiktok') ? _c('a', {
    attrs: {
      "href": ("https://www.tiktok.com/@" + (_vm.displayData.handle)),
      "target": "_blank"
    }
  }, [_vm._v("https://www.tiktok.com/" + _vm._s(_vm.displayData.handle))]) : _c('a', {
    attrs: {
      "href": ("https://www.instagram.com/" + (_vm.displayData.handle)),
      "target": "_blank"
    }
  }, [_vm._v("https://www.instagram.com/" + _vm._s(_vm.displayData.handle))]), _vm._v("\n                  )\n                ")])], 1), _vm._v(" "), _c('terms-and-conditions'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "max-width": "420px"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #cfcece",
      "margin-bottom": "10px"
    }
  }, [_c('canvas', {
    staticClass: "cls-signature-pad",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "signin-signature-pad",
      "width": "400",
      "height": "200"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.signatureImg,
      "width": "400",
      "height": "200"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "default-title mb-2"
  }, [_vm._v("Signature")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "loading": _vm.downloadloading,
      "disabled": _vm.downloadloading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.downloadPDF
    }
  }, [_vm._v("Download\n                "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0730ebca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/SigningForm/ViewModalDialog.vue
// module id = 1984
// module chunks = 0